/* eslint-disable no-undef */
import React, { Component } from "react";
import 'react-tabs/style/react-tabs.css';
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import MUIDataTable from "mui-datatables-bitozen";
import Api from "../../../../../Services/Api";
import API from "../../../../../Services/Api";
import FormJob from "./formJob";
import { checkResponseError } from "../../../../../Services/Utils";
import PopUp from "../../../../pages/PopUpAlert";
import FormUser from "./formUser";

import SimpleSearch from "../../../../../modules/SimpleSearch"
import EmployeeSearchForm from "../../../../../modules/commons/SearchEmployee";

const ct = require("../../../../../modules/custom/customTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());
const options = ct.customOptions6();

class TabMember extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: props.data ? props.data : {
                roleId: "",
                companyId: "",
                roleCode: "",
                roleName: "",
                accessType: "",
                memberTypeId: "",
                isLock: 0,
                status: "Active",
                action: "NEW"
            },
            memberJob: {
                jobTitle: ""
            },
            dataRoleMemberJob: [],
            dataMemberJob: [],
            memberUser: {
                user: ""
            },
            dataRoleMemberUser: [],
            selectedIndexJob: [],
            dataMemberUsers: [],
            selectedIndexUser: [],
            createJob: false,
            createUser: false,
            deletePopUpVisibleJob: false,
            deletePopUpVisibleUser: false,
            savePopUpVisible: false,
            loadSave: false,
            table_query_job: "",
            table_limit_job: 10,
            table_page_job: 0,
            table_query_user: "",
            table_limit_user: 10,
            table_page_user: 0,
            employeeSearchFormVisible: false,
        }
    }

    componentDidMount() {
        // console.log("ini props : " + JSON.stringify(this.props.data, null, 2))
        this.setDataValue(this.state.data);
    }

    setDataValue(data) {
        let dataCompany = {
            value: data.companyId,
            label: data.companyName
        }
        this.setState({
            data: {
                ...this.state.data,
                companyIdSelect: dataCompany,
            }
        }, () => {
            this.getRoleMemberJob(this.state.table_page_job, this.state.table_limit_job)
            this.getRoleMemberUser(this.state.table_page_user, this.state.table_limit_user)
        });
    }

    getRoleMemberJob = async (page, limit) => {
        let payload = {
            limit: limit,
            offset: page,
            roleId: this.state.data.roleId,
            jobTitle: this.state.memberJob.jobTitle
        }
        let res = await Api.create('MASTERDATA_EKSAD').postGetRoleMemberJob(payload)
        if (res.ok) {
            if (res.data.data === null) {
                this.setState({ dataMemberJob: [] })
            } else {
                let dataMemberJob = res.data.data && res.data.data.listRoleMemberJob.map((value) => {
                    const { jobTitle, description, total } = value;
                    return [jobTitle, description, total]
                })
                this.setState({
                    dataRoleMemberJob: res.data.data && res.data.data.listRoleMemberJob,
                    dataMemberJob,
                    countDataMemberJob: res.data.data && res.data.data.dataOfRecord
                })
                this.onFinishFetch();
            }
        }
    };

    getRoleMemberUser = async (page, limit) => {
        let payload = {
            limit: limit,
            offset: page,
            roleId: this.state.data.roleId,
            user: this.state.memberUser.user
        }
        let res = await Api.create('MASTERDATA_EKSAD').postGetRoleMemberUser(payload)
        if (res.ok) {
            if (res.data.data === null) {
                this.setState({ dataMemberUsers: [] })
            } else {
                let dataMemberUsers = res.data.data && res.data.data.listRoleMemberUser.map((value) => {
                    const { user, position } = value;
                    return [user, position]
                })
                this.setState({
                    dataRoleMemberUser: res.data.data && res.data.data.listRoleMemberUser,
                    dataMemberUsers,
                    countDataMemberUser: res.data.data && res.data.data.dataOfRecord
                })
                this.onFinishFetch();
            }
        }
    };

    openCreateJob = () => {
        this.setState({ createJob: !this.state.createJob });
    };

    openCreateUser = () => {
        this.setState({ createUser: !this.state.createUser });
    };

    startFetch = () => {
        this.LoadingBar.continousStart();
    };

    onFinishFetch = () => {
        if (typeof this.LoadingBar === 'object') this.LoadingBar.complete();
    };

    handleSubmit = async (response) => {
        this.checkResponse(response)
    }

    checkResponse(res, type) {
        if (res.ok && res.data.status === "S") {
            type === 'delete' && this.setState({ deletePopUpVisibleJob: false, deletePopUpVisibleUser: false })
            setTimeout(() => {
                this.openSavePopUp()
            }, 500);
        } else {
            this.isLoad(false)
            checkResponseError(res)
        }
    }

    isLoad(visible) {
        this.setState({ loadSave: visible });
    }

    openSavePopUp = () => {
        this.setState({ savePopUpVisible: !this.state.savePopUpVisible, loadSave: false })
    };

    handleDeleteJob = async () => {
        this.isLoad(true);
        let payload = { ...this.state.dataRoleMemberJob[this.state.selectedIndexJob] }
        payload.action = "DELETE";

        let response = await API.create('MASTERDATA_EKSAD').postSaveRoleMemberJob(payload)
        this.checkResponse(response, 'delete')
        this.isLoad(false);
    };

    openDeletePopupJob = (index) => {
        this.setState({ deletePopUpVisibleJob: !this.state.deletePopUpVisibleJob, selectedIndexJob: index })
    };

    handleDeleteUser = async () => {
        this.isLoad(true);
        let payload = { ...this.state.dataRoleMemberUser[this.state.selectedIndexUser] }
        payload.action = "DELETE";

        let response = await API.create('MASTERDATA_EKSAD').postSaveRoleMemberUser(payload)
        this.checkResponse(response, 'delete')
        this.isLoad(false);
    };

    openDeletePopupUser = (index) => {
        this.setState({ deletePopUpVisibleUser: !this.state.deletePopUpVisibleUser, selectedIndexUser: index })
    };

    handlePopUp = () => {
        this.getRoleMemberJob(this.state.table_page_job, this.state.table_limit_job)
        this.getRoleMemberUser(this.state.table_page_user, this.state.table_limit_user)
        this.setState({
            savePopUpVisible: false,
            createJob: false,
            createUser: false
        })
    }

    openSearchEmployee = () => {
        this.setState({ employeeSearchFormVisible: !this.state.employeeSearchFormVisible })
    }

    handleChooseEmployee = async (response) => {
        if (this.state.data.emplId != response.emplId) {
            this.onClickSaveRoleMember(response);
        }
    }

    onClickSaveRoleMember = async (response) => {
        let payload = {
            roleId: this.state.data.roleId,
            companyId: this.state.data.companyId,
            userId: response.userId,
            status: "Active",
            action: "NEW"
        }

        let res = await API.create('MASTERDATA_EKSAD').postSaveRoleMemberUser(payload)

        if (res.ok && res.data.status === 'S') {
            this.isLoad(false);
            this.handleSubmit(res);
        }
    }

    columnsMemberJob = [
        'Job Tittle',
        'Description',
        'Personnel',
        this.props.type !== 'view'
            ?
            {
                name: 'Action',
                options: {
                    customBodyRender: (val, tableMeta) => {
                        return (
                            <div style={{ width: '40px' }}>
                                <button className='btnAct' style={{ marginRight: 15, backgroundColor: 'transparent' }}
                                    onClick={() => this.openDeletePopupJob(tableMeta.rowIndex)}
                                >
                                    <i className='fa fa-lw fa-trash-alt'
                                        style={{ backgroundColor: 'transparent', color: 'red', fontSize: 20 }} />
                                </button>
                            </div>
                        );
                    },
                },
            } : '',
    ];

    columnsMemberUsers = [
        'User',
        'Position',
        this.props.type !== 'view'
            ?
            {
                name: 'Action',
                options: {
                    customBodyRender: (val, tableMeta) => {
                        return (
                            <div style={{ width: '40px' }}>
                                <button className='btnAct' style={{ marginRight: 15, backgroundColor: 'transparent' }}
                                    onClick={() => this.openDeletePopupUser(tableMeta.rowIndex)}
                                >
                                    <i className='fa fa-lw fa-trash-alt'
                                        style={{ backgroundColor: 'transparent', color: 'red', fontSize: 20 }} />
                                </button>
                            </div>
                        );
                    },
                },
            } : '',
    ];

    render() {
        let { countDataMemberJob, table_query_job, countDataMemberUser, table_query_user } = this.state;
        let tableOptionsJob = {
            ...options,
            serverSide: true,
            count: countDataMemberJob,
            searchText: table_query_job,
            search: false,
            viewColumns: false,
            rowsPerPage: this.state.table_limit_job,
            page: this.state.table_page_job,
            onTableChange: (action, tableState) => {
                switch (action) {
                    case 'changePage':
                        this.setState({ table_page: tableState.page });
                        this.getRoleMemberJob(tableState.page, tableState.rowsPerPage);
                        break;
                    case 'changeRowsPerPage':
                        this.setState({ table_limit: tableState.rowsPerPage });
                        this.getRoleMemberJob(tableState.page, tableState.rowsPerPage);
                        break;
                    case 'search':
                        let searchText = tableState.searchText ? tableState.searchText : '';
                        this.setState({ table_query: searchText }, () => {
                            this.getRoleMemberJob(tableState.page, tableState.rowsPerPage);
                        });
                        break;
                    default:
                        break;
                }
            }
        };
        let tableOptionsUser = {
            ...options,
            serverSide: true,
            count: countDataMemberUser,
            searchText: table_query_user,
            search: false,
            viewColumns: false,
            rowsPerPage: this.state.table_limit_user,
            page: this.state.table_page_user,
            onTableChange: (action, tableState) => {
                switch (action) {
                    case 'changePage':
                        this.setState({ table_page: tableState.page });
                        this.getRoleMemberUser(tableState.page, tableState.rowsPerPage);
                        break;
                    case 'changeRowsPerPage':
                        this.setState({ table_limit: tableState.rowsPerPage });
                        this.getRoleMemberUser(tableState.page, tableState.rowsPerPage);
                        break;
                    case 'search':
                        let searchText = tableState.searchText ? tableState.searchText : '';
                        this.setState({ table_query: searchText }, () => {
                            this.getRoleMemberUser(tableState.page, tableState.rowsPerPage);
                        });
                        break;
                    default:
                        break;
                }
            }
        };

        return (
            <div className="grid grid-2x">
                {this.props.isLock != 1 && <div className="col-2" style={{ marginRight: "20px" }}>
                    <div className="padding-tbl-monitoring">
                        <div>
                            <MuiThemeProvider theme={getMuiTheme()}>
                                <MUIDataTable
                                    key={countDataMemberJob}
                                    title={'Job'}
                                    data={this.state.dataMemberJob}
                                    columns={this.columnsMemberJob}
                                    options={tableOptionsJob}
                                    buttonCreate={this.props.type !== 'view'}
                                    onCreate={this.openCreateJob.bind(this)}
                                />
                            </MuiThemeProvider>
                        </div>
                        {this.state.createJob && (
                            <FormJob
                                type={"create"}
                                data={this.state.data}
                                loadSave={this.state.loadSave}
                                onClickClose={this.openCreateJob.bind(this)}
                                onClickSave={this.handleSubmit.bind(this)}
                            />
                        )}
                    </div>
                </div>
                }
                <div className="col-2" style={{ marginLeft: "12px" }}>
                    <div className="padding-tbl-monitoring">
                        <div>
                            <MuiThemeProvider theme={getMuiTheme()}>
                                <MUIDataTable
                                    key={countDataMemberUser}
                                    title={'Users'}
                                    data={this.state.dataMemberUsers}
                                    columns={this.columnsMemberUsers}
                                    options={tableOptionsUser}
                                    buttonCreate={this.props.type !== 'view'}
                                    onCreate={this.openSearchEmployee.bind(this)}
                                />
                            </MuiThemeProvider>
                        </div>
                        {this.state.employeeSearchFormVisible && (
                            <EmployeeSearchForm
                                category={"roleUser"}
                                companyId={this.state.data.companyId}
                                onClickClose={this.openSearchEmployee.bind(this)}
                                onChoose={this.handleChooseEmployee.bind(this)}
                                mandatory
                            />
                        )}
                    </div>
                </div>
                {this.state.savePopUpVisible && (
                    <PopUp
                        type={"save"}
                        class={"app-popup app-popup-show"}
                        onClick={this.handlePopUp.bind(this)}
                    />
                )}

                {this.state.deletePopUpVisibleJob && (
                    <PopUp
                        type={"delete"}
                        class={"app-popup app-popup-show"}
                        onClickDelete={this.handleDeleteJob}
                        onClick={this.openDeletePopupJob}
                        isLoading={this.state.loadSave}
                    />
                )}

                {this.state.deletePopUpVisibleUser && (
                    <PopUp
                        type={"delete"}
                        class={"app-popup app-popup-show"}
                        onClickDelete={this.handleDeleteUser}
                        onClick={this.openDeletePopupUser}
                        isLoading={this.state.loadSave}
                    />
                )}

            </div>

        )
    }
}

export default TabMember;